#import '../fragment/contract.graphql'

mutation saveContract($customerId: String!, $contract: ContractInput!) {
  saveContract(customerId: $customerId, contract: $contract) {
    ...contractFragment
  }
}
